import { useCallback, useMemo } from 'react';

import { IPaymentTrackerResponse } from '@model';
import { EHttpClient, IHttpHookResponse, httpMethods, useHttpClientAsync } from '@services/httpClientService';

import { ApiSectionNamespace } from '../../apiConstants';

import { PAYMENT_TRACKER_PLATFORM_WEB, PAYMENT_TRACKER_TYPE_WEB_CLIENT_INIT } from './constants';
import { IPaymentTrackerRequest, IPaymentTrackerRequestParams } from './model';

export const usePaymentTrackerOnDemand = (): IHttpHookResponse<
  IPaymentTrackerResponse,
  IPaymentTrackerRequestParams
> => {
  const asyncRequest = useHttpClientAsync<IPaymentTrackerResponse, IPaymentTrackerRequest>({
    method: httpMethods.POST,
    path: ApiSectionNamespace.EPaymentApiKeys.PAYMENT_TRACKER_PAYMENT,
    httpClientType: EHttpClient.CHECKOUT_GATEWAY,
  });

  const { request } = asyncRequest;

  const requestOnDemand = useCallback(
    (params?: IPaymentTrackerRequestParams) => {
      const data: IPaymentTrackerRequest = {
        type: PAYMENT_TRACKER_TYPE_WEB_CLIENT_INIT,
        platform: PAYMENT_TRACKER_PLATFORM_WEB,
        ...params,
      };
      return request({ data });
    },
    [request],
  );

  return useMemo(
    () => ({
      ...asyncRequest,
      request: requestOnDemand,
    }),
    [asyncRequest, requestOnDemand],
  );
};
